import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

export interface StripeConnectStatusDialogData {
  isFullyActive: boolean
  payoutsAtRisk: boolean
  eventuallyDue: string[]
  currentDeadline: string | null
}

/**
 * Shown when clicking the Stripe card for a project that's already started
 * Connect onboarding — a status summary instead of the KYC settings form
 * (which only makes sense the first time, before an account exists).
 */
@Component({
  selector: 'app-stripe-connect-status',
  templateUrl: './stripe-connect-status.component.html',
  styleUrl: './stripe-connect-status.component.scss'
})
export class StripeConnectStatusComponent {
  constructor(
    public dialogRef: MatDialogRef<StripeConnectStatusComponent>,
    @Inject(MAT_DIALOG_DATA) public data: StripeConnectStatusDialogData
  ) {}

  /** Stripe requirement keys (e.g. "company.registration_number") as readable labels. */
  get pendingRequirements(): string[] {
    return (this.data.eventuallyDue ?? []).map((key) =>
      key.split('.').pop()!.replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase())
    )
  }

  continueSetup(): void {
    this.dialogRef.close('continue')
  }

  openSettings(): void {
    this.dialogRef.close('settings')
  }

  close(): void {
    this.dialogRef.close()
  }
}
